import { render } from "./FilesTab.vue?vue&type=template&id=de77efe0&scoped=true"
import script from "./FilesTab.vue?vue&type=script&lang=js"
export * from "./FilesTab.vue?vue&type=script&lang=js"

import "./FilesTab.vue?vue&type=style&index=0&id=de77efe0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de77efe0"]])

export default __exports__